import { getImagesByQuery, PER_PAGE } from './js/pixabay-api';
import {
  createGallery,
  clearGallery,
  showLoader,
  hideLoader,
  hideLoadMoreButton,
  showLoadMoreButton,
  loadMoreBtn,
} from './js/render-functions';

import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';

const galleryEl = document.querySelector('.gallery');
const searchFormEl = document.querySelector('.search-form');
const searchBtn = searchFormEl.querySelector('button[type="submit"]');

let searchQuery;
let lightbox;
let currentPage;
let totalPages;

const onSearchFormSubmit = async evt => {
  evt.preventDefault();
  clearGallery();
  hideLoadMoreButton();
  searchQuery = evt.target.elements.searchText.value.trim();
  currentPage = 1;

  if (!searchQuery) {
    iziToast.warning({
      message: 'Please enter a search term!',
      position: 'topRight',
      transitionIn: 'fadeInLeft',
      transitionOut: 'fadeOutRight',
      timeout: 3000,
    });
    return;
  }

  searchBtn.disabled = true;
  showLoader();

  try {
    const { totalHits, hits } = await getImagesByQuery(
      searchQuery,
      currentPage
    );

    totalPages = Math.ceil(totalHits / PER_PAGE);

    if (!hits.length) {
      iziToast.warning({
        message:
          'Sorry, there are no images matching your search query. Please try again!',
        position: 'topRight',
        transitionIn: 'fadeInLeft',
        transitionOut: 'fadeOutRight',
        timeout: 3000,
      });
      return;
    }

    galleryEl.insertAdjacentHTML('beforeend', createGallery(hits));
    if (currentPage < totalPages) {
      showLoadMoreButton();
    }

    iziToast.success({
      message: 'Successfully found images!',
      position: 'topRight',
      transitionIn: 'fadeInLeft',
      transitionOut: 'fadeOutRight',
      timeout: 3000,
    });
    if (!lightbox) {
      lightbox = new SimpleLightbox('.gallery a', {
        captionsData: 'alt',
        captionsDelay: 250,
      });
    }
  } catch (error) {
    iziToast.error({
      message: error.message,
      position: 'topRight',
      transitionIn: 'fadeInLeft',
      transitionOut: 'fadeOutRight',
      timeout: 3000,
    });
  } finally {
    searchBtn.disabled = false;
    hideLoader();
  }
};

const smoothScrollonLoadMore = () => {
  const lastPictureCard = galleryEl.querySelector('li.gallery-item:last-child');
  const pictureCardRectBottom = lastPictureCard.getBoundingClientRect().bottom;
  window.scrollBy({
    top: pictureCardRectBottom,
    behavior: 'smooth',
  });
};

const onLoadMorePressed = async () => {
  currentPage += 1;

  try {
    showLoader();
    const { hits } = await getImagesByQuery(searchQuery, currentPage);

    galleryEl.insertAdjacentHTML('beforeend', createGallery(hits));

    if (lightbox) {
      lightbox.refresh();
    }

    smoothScrollonLoadMore();

    if (currentPage === totalPages) {
      hideLoadMoreButton();
      loadMoreBtn.removeEventListener('click', onLoadMorePressed);
      iziToast.warning({
        message: "We're sorry, but you've reached the end of search results.",
        position: 'topRight',
        transitionIn: 'fadeInLeft',
        transitionOut: 'fadeOutRight',
        timeout: 3000,
      });
    }
  } catch (error) {
    iziToast.error({
      message: error.message,
      position: 'topRight',
      transitionIn: 'fadeInLeft',
      transitionOut: 'fadeOutRight',
      timeout: 3000,
    });
  } finally {
    hideLoader();
  }
};

searchFormEl.addEventListener('submit', onSearchFormSubmit);

loadMoreBtn.addEventListener('click', onLoadMorePressed);
